/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `video_clip` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class VideoClipMesg : Mesg {
    public constructor() : super("VideoClip", Profile.MesgNum.VIDEO_CLIP)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** clip_number. */
    public var clipNumber: UShort?
        get() = getFieldValue(CLIP_NUMBER_FIELD_NUM) as? UShort
        set(value) = setFieldValue(CLIP_NUMBER_FIELD_NUM, value)

    /** start_timestamp. */
    public var startTimestamp: Instant?
        get() = (getFieldValue(START_TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(START_TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** start_timestamp_ms. */
    public var startTimestampMs: UShort?
        get() = getFieldValue(START_TIMESTAMP_MS_FIELD_NUM) as? UShort
        set(value) = setFieldValue(START_TIMESTAMP_MS_FIELD_NUM, value)

    /** end_timestamp. */
    public var endTimestamp: Instant?
        get() = (getFieldValue(END_TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(END_TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** end_timestamp_ms. */
    public var endTimestampMs: UShort?
        get() = getFieldValue(END_TIMESTAMP_MS_FIELD_NUM) as? UShort
        set(value) = setFieldValue(END_TIMESTAMP_MS_FIELD_NUM, value)

    /** clip_start, in ms. Start of clip in video time */
    public var clipStart: UInt?
        get() = getFieldValue(CLIP_START_FIELD_NUM) as? UInt
        set(value) = setFieldValue(CLIP_START_FIELD_NUM, value)

    /** clip_end, in ms. End of clip in video time */
    public var clipEnd: UInt?
        get() = getFieldValue(CLIP_END_FIELD_NUM) as? UInt
        set(value) = setFieldValue(CLIP_END_FIELD_NUM, value)

    public companion object {
        public const val CLIP_NUMBER_FIELD_NUM: UByte = 0u
        public const val START_TIMESTAMP_FIELD_NUM: UByte = 1u
        public const val START_TIMESTAMP_MS_FIELD_NUM: UByte = 2u
        public const val END_TIMESTAMP_FIELD_NUM: UByte = 3u
        public const val END_TIMESTAMP_MS_FIELD_NUM: UByte = 4u
        public const val CLIP_START_FIELD_NUM: UByte = 6u
        public const val CLIP_END_FIELD_NUM: UByte = 7u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("ClipNumber", 0u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[1] = Field("StartTimestamp", 1u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[2] = Field("StartTimestampMs", 2u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[3] = Field("EndTimestamp", 3u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[4] = Field("EndTimestampMs", 4u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[6] = Field("ClipStart", 6u, BaseType.UINT32, 1.0, 0.0, "ms", false)
            fields[7] = Field("ClipEnd", 7u, BaseType.UINT32, 1.0, 0.0, "ms", false)
            return fields
        }
    }
}
